import cx from 'classnames'
import React from 'react'
import useStyles from './Styles'
import { IProps, Corner } from './Interface'
import { Box } from '@material-ui/core'

const Balloon: React.FC<IProps> = ({ children, corner, bgColor, size, shadow, borderRadius, className, ...props }) => {
  const classes = useStyles({ corner, bgColor, size, shadow, borderRadius })

  return (
    <Box className={cx(classes.root, className)} {...props}>
      <div className={classes.content}>{children}</div>
    </Box>
  )
}

Balloon.defaultProps = {
  bgColor: '#2d4ba2',
  corner: Corner.BottomLeft,
  size: 50,
  shadow: true,
  borderRadius: '50% 50% 50% 0'
}

export default Balloon
